<template>
    <div>
      <a-modal
        :visible="visible"
        wrapClassName="responsive-modal"
        title="授权"
        :confirmLoading="confirmLoading"
        @ok="right"
        @cancel="hide()"
        closable
      >
        <Layout :showMenu="false" :menuList="menuList" :defaultKeys="[0]" :activeKey.sync="key" :mainImage="true" :mainImageUrl="record.images.length ? record.images[0] : ''" >
          <template slot="content" >
            <div v-show="key === 0" style="height:100%">
              <div class="font-14 font-bold m-b-20" style="color: #363B45" >{{ menuList[key].name }}</div>

              <Area :region.sync="region"  />
              <a-card style="width: 100%" v-if="checkedObj.region" class=" m-t-20" >
                <tk-flex slot="title" between middle >
                  <tk-flex meddle class="font-12" >
                    <div v-if="checkedObj.tradePrice === ''" class="btn-blue" >默认</div>
                    <div v-else class="btn-yellow" >修改</div>
                    <div class="m-t-2 m-l-12" >{{record.isService ? '活动价' : '以旧换新价'}}：</div>
                    <div class="m-t-2" v-if="!checkedObj.edit" style="color: #FF2A58" >{{ checkedObj.tradePrice === '' ? record.tradePrice : checkedObj.tradePrice }}</div>
                    <a-input-number v-else  size="small" style="width: 60px" :parser="value => parser(value)" v-model="checkedObj.tradePrice" :min="0" :max="99999" />

                    <div class="m-t-2 m-l-12" >{{record.isService ? '原价' : '直接购买价'}}：</div>
                    <div class="m-t-2" v-if="!checkedObj.edit" style="color: #FF2A58" >{{ checkedObj.price === '' ? record.price : checkedObj.price }}</div>
                    <a-input-number v-else  size="small" style="width: 60px" :parser="value => parser(value)" v-model="checkedObj.price" :min="0" :max="99999" />

                    <a-button v-if="!checkedObj.edit" size="small" class="font-12 m-l-30" @click="checkedObj.edit = true" >编辑</a-button>
                    <a-button v-if="checkedObj.edit" size="small" class="font-12 m-l-30" @click="save" >保存</a-button>
                    <a-button v-if="checkedObj.edit" size="small" class="font-12 m-l-30" @click="cancel" >取消</a-button>

                  </tk-flex>
                  <a-checkbox :checked="checkedObj.all" @change="onChange">
                    全选
                  </a-checkbox>
                </tk-flex>
                <a-spin :spinning="loading" class="p-x-8">
                  <a-row :gutter="[16,16]" class="public-clean-side full-width">
                    <div class="full-width">
                      <a-col
                        v-for="(s, index) in checkedObj.list"
                        :key="index"
                        :xs="12"
                        :sm="8"
                        :md="6"
                        :lg="4"
                      >
                        <a-checkbox
                          :checked="s.select"
                          @change="oneChange(s, index)"

                        >{{ s.nickName }}</a-checkbox>
                      </a-col>
                    </div>
                  </a-row>
                </a-spin>
              </a-card>
            </div>
          </template>
        </Layout>
      </a-modal>
    </div>
  </template>

<script>
import Area from './area.vue'
import Layout from '../../components/layout.vue'
export default {
  props: {
    pageData: Object,
    visible: {
      type: Boolean,
      default: true
    },
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
  data () {
    return {
      confirmLoading: false,
      menuList: [
        {
          name: '基本信息'
        }
        // {
        //   name: '授权代理商'
        // },
        // {
        //   name: '买赠设置'
        // }
      ],
      key: 0,
      region: '',
      alreadyUser: [], // 已经授权的代理商
      accreditObj: {}, // 代理商列表
      checkedObj: {}, // 当前选中的代理商数据
      checkedList: [], // 选中的代理商id
      loading: false

    }
  },
  // 组件
  components: {
    Layout,
    Area
  },
  computed: {
    // _visible: {
    //   get () {
    //     return this.value
    //   },
    //   set (v) {
    //     console.log(v)
    //     // v-model接收input事件的值来更新value
    //     this.$emit('update:visible', v)
    //   }
    // }
  },
  watch: {
    region (val) {
      this.checkedObj = {
        edit: false,
        region: val,
        all: false,
        tradePrice: this.record.tradePrice,
        price: this.record.price,
        list: []
      }
      if (val) {
        this.getUser()
      }
    }
  },
  mounted () {
    this.getAgent()
  },
  methods: {
    parser (value) {
      // eslint-disable-next-line no-useless-escape
      return value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/\.{2,}/g, '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    },
    onChange (e) {
      this.checkedObj.all = e.target.checked
      this.checkedObj.list.forEach(item => {
        item.select = e.target.checked
        if (e.target.checked) {
          this.checkedList.push(item.objectId)
        } else {
          this.checkedList.splice(this.checkedList.indexOf(item.objectId), 1)
        }
      })

      this.accreditObj[this.region] = JSON.parse(JSON.stringify(this.checkedObj))
    },
    // 获取全部代理商
    async getAgent () {
      const { data } = await this.$tkParse.get('/classes/winWinMerchantProduct', {
        params: {
          include: 'winWinMerchant',
          limit: 50000,
          where: {
            isDelete: false,
            commodity: this.record.objectId
          }
        }
      })
      console.log(data.results)
      this.alreadyUser = data.results
      let obj = {}
      data.results.forEach(item => {
        if (item.winWinMerchant) {
          this.checkedList.push(item.winWinMerchant.objectId)
        }
        // 判断key为item.winWinMerchant.region的对象是否存在
        console.log(obj[item.winWinMerchant.regional])
        if (obj[item.winWinMerchant.regional]) {
          obj[item.winWinMerchant.regional].list.push({
            select: true,
            objectId: item.winWinMerchant.objectId
          })
        } else {
          obj[item.winWinMerchant.regional] = {
            edit: false,
            region: item.winWinMerchant.regional,
            all: false,
            tradePrice: item.tradePrice || '',
            price: item.price || '',
            list: [{
              select: true,
              objectId: item.winWinMerchant.objectId
            }]
          }
        }
      })
      console.log(obj)
      this.accreditObj = obj
    },
    // 获取代理商
    async getUser () {
      // 获取市
      let res = await this.$tkParse.get('/classes/_User', {
        params: {
          limit: 1000,
          where: {
            adminRole: 'staff',
            regional: this.region,
            level: '3',
            isDelete: { $ne: true }
          }
        }
      })
      // console.log('代理商', res.data.results)
      res.data.results.forEach(item => {
        // 判断checkedList是否包含当前id
        if (this.checkedList.includes(item.objectId)) {
          item.select = true
        } else {
          item.select = false
        }
      })

      if (this.accreditObj[this.region]) {
        this.accreditObj[this.region].list = res.data.results
      } else {
        this.accreditObj[this.region] = {
          edit: false,
          region: this.region,
          all: false,
          tradePrice: '',
          price: '',
          list: res.data.results
        }
      }
      // console.log('全部的', this.accreditObj)
      // console.log(this.region)
      // 深拷贝
      this.checkedObj = JSON.parse(JSON.stringify(this.accreditObj[this.region]))
      // console.log(this.checkedObj)
    },
    cancel () {
      this.accreditObj[this.region].edit = false
      this.checkedObj = JSON.parse(JSON.stringify(this.accreditObj[this.region]))
    },
    save () {
      this.checkedObj.edit = false
      this.accreditObj[this.region] = JSON.parse(JSON.stringify(this.checkedObj))
      // this.$notification['success']({
      //   message: '成功',
      //   description: '保存成功'
      // })
    },
    oneChange (item, index) {
      this.checkedObj.all = false
      item.select = !item.select
      if (item.select) {
        this.checkedList.push(item.objectId)
      } else {
        this.checkedList.splice(this.checkedList.indexOf(item.objectId), 1)
      }
      this.checkedObj.list[index].select = item.select
      this.accreditObj[this.region] = JSON.parse(JSON.stringify(this.checkedObj))
    },
    // 确认
    async right () {
      console.log(this.accreditObj)
      let that = this
      // 弹框确认 是否要删除 确认后继续执行下面代码
      await this.$confirm({
        title: '警告',
        content: '是否确认授权/取消授权？若取消代理商相关门店商品将一并删除，请谨慎操作。',
        onOk () {
          that.confirm()
        },
        onCancel () {
        }
      })
    },
    // 保存
    async confirm () {
      this.confirmLoading = true
      try {
        // 判断this.accreditObj 是否有值
        if (Object.keys(this.accreditObj).length !== 0) {
          await this.$tkParse.post(`/commodity/WWMProduct`, {
            commodity: this.record.objectId,
            obj: this.accreditObj
          })
        }
        this.confirmLoading = false
        this.$notification['success']({
          message: '成功',
          description: '添加成功'
        })
        this.hide()
        this.vm.refreshAgent()
        this.vm.showAccredit = false
        // this.vm.$refs.management.$refs.table.refresh()
      } catch (e) {
        console.log('错误', e)
        this.confirmLoading = false
        this.$notification['error']({
          message: '错误',
          description: '添加失败'
        })
      }
    },
    hide () {
      this.vm.showAccredit = false
      // this._visible = false
    }
  }
}
</script>

<style lang="scss" scoped>

::v-deep{
    .ant-form-item-label > label::after{
        display: none;
    }
    .ant-modal-body{
        padding: 0;
    }
}
.label{
    display: block;
    margin: 0;
    padding: 0 0 8px;
    line-height: 1.5;
    white-space: initial;
    text-align: left;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
}

</style>
